<template>
  <NewGlassCard
    id="technical-details"
    :class="
      this.$vuetify.breakpoint.xl
        ? 'xl-design-details-page-element default-mb'
        : 'default-mb'
    "
    class="z-index-0"
    :title="$t('consumption_devices.order_details.technical_details')"
  >
    <!-- All Consumption Devices -->
    <div
      v-for="(
        devices, deviceType
      ) in consumptionDevicesOrder.controllable_devices"
      :key="deviceType"
    >
      <div v-for="(deviceData, uuid) in devices" :key="uuid" class="mb-3">
        <SingleConsumptionDeviceDetails
          :consumptionDevice="deviceData"
          :currentDeviceName="deviceType"
          :deviceUuid="uuid"
          @edit-component="$emit('edit-component', $event)"
        />
      </div>
    </div>

    <!-- General Technical Data -->
    <!--GeneralTechnicalData
      :consumptionDevicesOrder="consumptionDevicesOrder"
      @edit-component="$emit('edit-component', $event)"
    /-->
  </NewGlassCard>
</template>

<script>
import { NewGlassCard } from '@newnetzportal/netzportal-webapp-storybook-components';
import SingleConsumptionDeviceDetails from './SingleConsumptionDeviceDetails.vue';

export default {
  name: 'TechnicalDetails',
  components: {
    NewGlassCard,
    SingleConsumptionDeviceDetails,
  },
  props: {
    consumptionDevicesOrder: Object,
  },
};
</script>

<style scoped>
.row-item {
  margin-block: 1px;
}
</style>
